import { useEffect, useState } from "react";

// Hook responsive: true khi viewport < breakpoint (mặc định 768px — khớp Tailwind `md`).
// Dùng để đổi hẳn layout (bảng ↔ card) thay vì chỉ ẩn/hiện bằng CSS,
// tránh mount 2 bản UI cùng lúc với danh sách dài.
function useIsMobile(breakpoint = 768) {
    const query = `(max-width: ${breakpoint - 1}px)`;
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = (e) => setIsMobile(e.matches);
        mql.addEventListener("change", onChange);
        return () => mql.removeEventListener("change", onChange);
    }, [query]);

    return isMobile;
}

export default useIsMobile;
